import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import { portfolioData } from '../mock';

const Home = () => {
  return (
    <>
      <Hero data={portfolioData} />
      <About data={portfolioData} />
    </>
  );
};

export default Home;